export default __webpack_public_path__ + "static/media/Conscript's Armguards of the Ascending Kingdom.75995b4d.jpg";